<template>
  <v-app>

    <Drawer />

    <v-content>
      <div v-if="error" class="mx-auto mt-4" style="max-width: 500px;">
        <mikro-alert @dismissed="onDismiss" :text="error.message"></mikro-alert>
      </div>
      <router-view></router-view>
    </v-content>

  </v-app>
</template>

<script>

import Drawer from './components/Drawer'

export default {
  name: 'App',
  components: {
    Drawer
  },
  data () {
    return {
      //
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    }
  },
  methods: {
    onDismiss () {
      console.log('dismissed')
      this.$store.dispatch('clearError')
    }
  }
}

</script>
